const Collections = {
    sexos: [
        { id: 'F', text: "Feminino" },
        { id: 'M', text: "Masculino" }
    ],

    simNao: [
        { id: 'T', text: "Todos" },
        { id: 'S', text: "Sim" },
        { id: 'N', text: "Não" }
    ],

    tipoPagina: [
        { id: 'apolices', text: "Apólices" },
        { id: 'central-atendimento', text: "Central de Atendimento" },
        { id: 'clinicas-petshops', text: "Clínicas e Petshops" },
        { id: 'cupons-desconto', text: "Cupons de Desconto" },
        { id: 'manual-usuario', text: "Manual Usuário" },
        { id: 'rede-credenciada', text: "Rede Credenciada" }
    ],

    tipoAutenticacao: [
        { id: 'codigo', text: "Código" },
        { id: 'telefone', text: "Telefone" }
    ],

    camposObrigatorios: [
        { id: 'email', text: "E-mail" },
        { id: 'nome', text: "Nome" },
        { id: 'telefone', text: "Telefone" }
    ],

    tipoClinica: [
        { id: 'C', text: "Clínica" },
        { id: 'L', text: "Loja Virtual" },
        { id: 'P', text: "Petshop" },
        { id: 'R', text: "Rede Credenciada" }
    ],

    tiposDesconto: [
        {id: 'P', text: "Percentual"},
        {id: 'V', text: "Valor"}
    ],

    categoriaDesconto: [
      {id: 'F', text: "Físico"},
      {id: 'O', text: "Online"}
    ],

    assinaturaTipo: [
        { id: 'T', text: "Todos" },
        { id: 'android', text: "Android" },
        { id: 'ios', text: "IOS" },
        { id: 'vivo', text: "Vivo" },
        { id: 'att', text: "AT&T" },
        { id: 'claro_colombia', text: "Claro Colômbia" },
        { id: 'telcel', text: "Telcel" },
    ],

    assinaturaPais: [
        { id: 'T', text: "Todos" },
        { id: 'BR', text: "Brasil" },
        { id: 'MX', text: "México" },
        { id: 'CL', text: "Colômbia" },
    ],

    assinaturaIntegradora: [
        { id: 'T', text: "Todos" },
        { id: 'A', text: "Agrega" },
        { id: 'S', text: "Syntonic" }
    ],

    perfisUsuarioAdmin: [
        { id: 'A', text: "Administrador" },
        { id: 'U', text: "Usuário" },
        { id: 'T', text: "Conteúdo" }
    ],

    assinaturaStatus: [
        { id: 'T', text: "Todos" },
        { id: 'I', text: "Ativo" },
        { id: 'C', text: "Cancelado" },
        { id: 'S', text: "Sem Assinatura" }
    ],

    idiomas: [
        { id: 'pt', text: "Português" },
        // { id: 'EN', text: "Inglês" },
        // { id: 'FR', text: "Francês" },
        { id: 'es', text: "Espanhol" }
    ],

    tiposVacina: [
        { id: 'V', text: "Vacina" },
        { id: 'E', text: "Vermífugo" }
    ],

    tiposPost: [
        { id: 'P', text: "Post" },
        { id: 'V', text: "Vídeo" }
    ],
    aplicacaoPeriodo: [
        { id: "H", text: "Hora(s)" },
        { id: "D", text: "Dia(s)" },
        { id: "S", text: "Semana(s)" },
        { id: "M", text: "Mes(es)" },
        { id: "A", text: "Ano(s)" }
    ],
    periodo: [
        { id: "S", text: "Semana(s)" },
        { id: "M", text: "Mes(es)" },
        { id: "A", text: "Ano(s)" }
    ],
    lembrete: [
        { id: "I", text: "Minuto(s)" },
        { id: "H", text: "Hora(s)" },
        { id: "D", text: "Dia(s)" },
        { id: "S", text: "Semana(s)" },
        { id: "M", text: "Mes(es)" },
        { id: "A", text: "Ano(s)" }
    ],
    banhos: [
        { id: "true", text: "Sim" },
        { id: "false", text: "Não" },
        { id: "null", text: "Todos" }
    ],
    meses: [
        { text: "Todos", id: "T" },
        { text: "Janeiro", id: "0" },
        { text: "Fevereiro", id: "1" },
        { text: "Março", id: "2" },
        { text: "Abril", id: "3" },
        { text: "Maio", id: "4" },
        { text: "Junho", id: "5" },
        { text: "Julho", id: "6" },
        { text: "Agosto", id: "7" },
        { text: "Setembro", id: "8" },
        { text: "Outubro", id: "9" },
        { text: "Novembro", id: "10" },
        { text: "Dezembro", id: "11" }
    ],
}
export default Collections;



// WEBPACK FOOTER //
// ./src/helpers/collections.js